import React, { SVGAttributes } from 'react';

export const TV = (props: SVGAttributes<SVGElement>) => (
  <svg viewBox="0 0 24 24" {...props}>
    <path d="M21 17H3V5h18m0-2H3a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h5a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2z" />
  </svg>
);
